<template>
  <div id="photo">
    <div class="photo_top">
      <img :src="avatar" class="img" />
      <span id="span" :title="item.account">{{
        item.name != "" ? item.name : item.account
      }}</span>
    </div>
    <div id="user_d">
      <div class="daeweee">
        <img :src="avatar" width="100%" style="margin-bottom: 10px" />
        <div id="deweewe">
          <Icon type="md-person" title="编辑资料" @click="openAdd" />

          <Icon type="md-lock" title="修改密码" @click="openPw" />

          <Icon type="md-settings" title="配置属性" @click="openProperty" />
          <Icon type="md-exit" title="退出系统" @click="logOut" />
        </div>
      </div>

      <Row class="row" style="margin-bottom: 15px">
        <Col span="7" class="list"> 备注名 </Col>
        <Col span="17">
          <p style="float: right; color: #999">
            {{ item.name }}
          </p>
        </Col>
      </Row>
      <Row class="row">
        <Col span="7" class="list"> 电话 </Col>
        <Col span="17">
          <p style="float: right; color: #999">
            {{ item.tel }}
          </p>
        </Col>
      </Row>
      <slot></slot>
    </div>

    <form-model title="更改个人信息" width="400" ref="formModel">
      <Button slot="btn" type="primary" @click="setSelfInfo">提交表单</Button>
    </form-model>
    <form-model title="更改密码" width="400" ref="mima">
      <Button slot="btn" type="primary" @click="updatePwd">提交保存</Button>
    </form-model>
    <form-model title="个人配置" width="400" ref="peizhi">
      <Button slot="btn" type="primary" @click="property">提交保存</Button>
    </form-model>
  </div>
</template>
<script>
var axios;
var map;

export default {
  data() {
    return {
      modal: false,
      openPasswordForm: false,
      openPropertyForm: false,
      myImg: [],
      item: {
        tel: "",
        name: "",
        avatar: "",
        contact: "",
      },
      forms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          span: 24,
        },
        {
          title: "电话",
          key: "tel",
          type: "Input",
          span: 24,
        },
        {
          title: "视频控件",
          key: "contact",
          type: "Select",
          selectItems: ["云视频"],
          clearable: true,
          span: 24,
        },
        {
          title: "头像",
          key: "avatar",
          type: "lyPhoto",
          one: true,
          span: 24,
        },
      ],
      pwItem: {
        oldPassword: "",
        newPassword: "",
      },
      pwForms: [
        {
          title: "旧密码",
          key: "oldPassword",
          type: "Input",
          span: 24,
          required: true,
        },
        {
          title: "新密码",
          key: "newPassword",
          type: "Input",
          span: 24,
          required: true,
        },
      ],
      propertyItem: {
        zoom: 13,
        mapCenter: [116.397451, 39.909187],
        diragreen: 0,
        meter: 0,
      },
      propertyForms: [
        {
          title: "轨迹过滤方向度数",
          key: "diragreen",
          type: "InputNumber",
          span: 24,
        },
        {
          title: "轨迹过滤间隔距离",
          key: "meter",
          type: "InputNumber",
          span: 24,
        },
      ],
      address: "",
      avatar: "",
    };
  },
  methods: {
    reachData() {},
    //退出登录
    logOut() {
      this.$Modal.confirm({
        title: "确定要退出登录吗？",
        // content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.commonAuth + "/auth/logout",
            data: {
              accessToken: this.axios.keyObj.accessToken,
            },
          }).then((res) => {
            if (res.data.code == 200) {
              sessionStorage.removeItem(this.axios.plat);
              location.reload();
            }
          });
        },
      });
    },
    //获取用户名
    getUser() {
      this.axios({
        method: "post",
        url: "/account/getUserItem",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        //把当前用户存起来，表单填写用到
        sessionStorage.setItem("loginUser", JSON.stringify(data));
        this.axios.user = data;
        data.contact = this.utils.isEmpty(data.contact) ? "" : data.contact;
        this.avatar =
          data.avatar == null
            ? "static/photo.jpg"
            : this.axios.platConfig.fileUri + data.avatar;
        this.item.tel = this.utils.text(data.tel, "");
        this.item.name = data.name && data.name != "" ? data.name : ""; //this.utils.text(data.name, "");
        this.item.account = data.account;
        this.item.avatar = data.avatar;
        this.item.contact = data.contact;
        var msyy = localStorage.getItem("contact");

        if (data.contact != msyy) {
          localStorage.setItem("contact", data.contact); //用来做视频的控件判断
          location.reload();
        }

        if (data.avatar != null) {
          this.item.avatarArr = [data.avatar];
        }
      });
    },
    openAdd() {
      this.$refs.formModel.reach(this.forms, this.item);
    },
    setSelfInfo() {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.axios({
        method: "post",
        url: "/account/updateUserItem",
        data: this.item,
      }).then((res) => {
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.$Message.success({
            content: "修改成功",
            duration: 2,
          });
          this.$refs.formModel.close();
          this.getUser();
        }
      });
    },
    openPw() {
      this.$refs.mima.reach(this.pwForms, this.pwItem);
    },
    updatePwd(name) {
      var a = this.$refs.mima.getItem();
      if (!a) {
        return;
      }
      /* var pwdRegex = new RegExp(
        "(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}"
      );

      if (!pwdRegex.test(this.formItem.newPassword)) {
        alert(
          "您的密码复杂度太低（密码中必须包含字母、数字、特殊字符），请及时修改密码！"
        );
        return false;
      } */

      if (this.pwItem.oldPassword.length < 6) {
        this.$Message.error({
          content: "旧密码不足6位",
          duration: 2,
        });
        return;
      } else if (this.pwItem.newPassword.length < 6) {
        this.$Message.error({
          content: "新密码不足6位",
          duration: 2,
        });
        return;
      }

      this.axios({
        method: "post",
        url: "/account/updatePassword",
        data: this.pwItem,
      }).then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          this.$Message.error({
            content: res.data.message,
            duration: 2,
          });
        } else {
          this.$Message.success({
            content: "修改成功，请用新密码登录",
            duration: 5,
          });
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    openProperty() {
      this.$refs.peizhi.reach(this.propertyForms, this.propertyItem);
    },
    property() {
      this.axios({
        method: "post",
        url: this.axios.oss + "/property/save",
        data: { customProperty: JSON.stringify(this.propertyItem) },
      }).then((res) => {
        if (res) {
          this.$refs.peizhi.close();
        }
      });
    },
    getProperty() {
      this.axios({
        method: "post",
        url: this.axios.oss + "/property/select",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        data.customProperty = JSON.parse(data.customProperty);
        console.log(data.customProperty);
        this.axios.platConfig = data.publicProperty;

        var t = data.customProperty;
        var obj = {
          zoom: 13,
          mapCenter: [116.397451, 39.909187],
          diragreen: 0,
          meter: 0,
        };

        this.propertyItem = t == null ? obj : t;
        this.axios.mapConfig = this.propertyItem;
        this.getUser();
      });
    },
  },
  mounted() {
    this.getProperty();
  },
};
</script>
<style lang="">
#photo {
  margin-top: 10px;
  float: left;
  position: relative;
}
#photo .photo_top {
  cursor: default;
}
#photo .img {
  width: 30px;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: middle;
  border: solid 2px #fff;
}
#photo #span,
#photo #photodown {
  color: var(--fontColor);
}
#photo #span {
  display: inline-block;
  max-width: 60px;
  height: 36px;
  overflow: hidden;
  vertical-align: middle;
}
#user_d {
  width: 180px;
  background: #fff;
  box-shadow: #999 0px 6px 12px 0px;
  position: absolute;
  right: 0;
  text-align: left;
  padding: 10px;
  margin-top: 0px;
  z-index: 123;
  display: none;
}
#user_d .daeweee {
  width: 100%;
  position: relative;
}
#user_d .daeweee #deweewe {
  position: absolute;
  left: 0;
  bottom: 14px;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  padding: 6px;
}
#user_d .daeweee #deweewe i {
  color: #fff;
  font-size: 16px;
  margin-right: 10px;
}
#user_d .daeweee #deweewe i:hover {
  cursor: pointer;
}
#photo:hover #user_d {
  display: block;
}
#mappp {
  width: 100%;
  height: 400px;
  background: #ccc;
  position: relative;
}
#mappp #form {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 300px;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/sys/user.vue